export const isBrowser: boolean = typeof window !== 'undefined';

export function getServerAddress() {
    if (isBrowser) {
        return process.env.NEXT_NGINX_HOST;
    }

    return process.env.NGINX_HOST;
}